import { MutableRefObject, useEffect, useRef } from "react";

interface Props {
  ref: MutableRefObject<HTMLElement>;
  onClickOutsideCb: () => void;
  shouldHandleClick?: boolean;
}

const useClickOutside = ({ ref, onClickOutsideCb, shouldHandleClick = true }: Props): void => {
  const shouldHandleClickRef = useRef(shouldHandleClick);

  const handleClick = (event: Event): void => {
    if (!shouldHandleClickRef.current) return;

    if (ref?.current?.contains(event.target as Node)) return;

    onClickOutsideCb();
  };

  /**
   * Set shouldHandleClickRef based on shouldHandleClick state change
   * for value usage in click event listener
   */
  useEffect(() => {
    shouldHandleClickRef.current = shouldHandleClick;
  }, [shouldHandleClick]);

  useEffect(() => {
    // Return undefined for consisten return value
    if (!ref.current) return undefined;

    window.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [ref]);
};

export default useClickOutside;
